import type { NavigateFunction } from "react-router";
import { openArtifactById } from "@/components/artifacts/openArtifactDestination";
import type { OpenWindowConfig } from "@/components/ui/os-layout/useWindow";
import { executeNavIntent } from "@/services/agent/agentNavigation";
import type { ChatEntityPreviewEmbed } from "./types";

export type EntityPreviewOpenDeps = {
  navigate: NavigateFunction;
  openWindow: (config: OpenWindowConfig) => void;
  /** When true, prefer ``openWindow`` over route navigation (AniOS layout). */
  inOsLayout?: boolean;
};

/** Open the entity referenced by a chat ``entity_preview`` embed. */
export function openEntityPreview(
  embed: ChatEntityPreviewEmbed,
  { navigate, openWindow, inOsLayout = false }: EntityPreviewOpenDeps,
): void {
  if (embed.entity_type === "artifact") {
    void openArtifactById(embed.id, openWindow, {
      mode: "view",
      title: embed.label,
    });
    return;
  }

  executeNavIntent(
    {
      mode: "detail",
      entityKind: embed.entity_type,
      id: embed.id,
      label: embed.label,
    },
    {
      inOsLayout,
      openWindow: (target) =>
        openWindow({
          appId: target.appId,
          title: target.title,
          params: target.params,
        }),
      navigate: (path) => navigate(path),
    },
  );
}
